export default __webpack_public_path__ + "static/media/Pungent Absorber.8ce606f5.jpg";